<template>
    <div class="row align-items-center">
        <div class="col-11 pr-0">
            <ValidationObserver :ref="'contact' + contact.name" class="row">

                <ValidationProvider rules="required|latin|min:2|max:30"
                                    name="Emergency contact: Name"
                                    v-slot="{ errors }" class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Name</label>
                        <input type="text" class="form-control" v-model="contact.name">
                        <FormError :error="errors[0]"  name="Emergency contact: Name"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider rules="required|latinAndNumbers"
                                    name="Emergency contact: How long know"
                                    v-slot="{ errors }" class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">How long know</label>
                        <input type="text" class="form-control" v-model="contact.term_know">
                        <FormError :error="errors[0]"  name="Emergency contact: How long know"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider rules="required|customMin:17"
                                    name="Emergency contact: Telephone"
                                    v-slot="{ errors }" class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Telephone / Fax</label>
                        <input type="text" class="form-control"
                               v-mask="'+1 (###) ###-####'"
                               v-model="contact.phone">
                        <FormError :error="errors[0]" name="Emergency contact: Telephone"></FormError>
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <div class="col-1" v-if="lengthCnt > 1">
            <a  href="javascript:void(0)" class="delete-link"
                    @click.prevent="$emit('delete-contact', contact.id)"
            ><img src="/uploads/img/svg/on.svg" alt=""></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'emergency-contacts',
    emits: ['delete-contact'],
    props: {
        user: {
            type:Object
        },
        contact: {
            type: Object,
        },
        lengthCnt: {
            type: Number,
            required: true
        }
    },
}

</script>

<style scoped>

</style>
